/**
 * useLocations Hook
 * Fetch locations from the database for use across the application
 */

import { useQuery } from '@tanstack/react-query';
import { getLocations, type LocationConfig } from '@/modules/child-registration/services/locationsService';

/**
 * Hook to fetch all locations from the database
 * Uses React Query for caching and refetching
 */
export function useLocations({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery<LocationConfig[], Error>({
    queryKey: ['locations'],
    queryFn: getLocations,
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes - locations don't change often
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}

export type { LocationConfig };
export { getLocations };
